/* eslint-disable import/prefer-default-export, camelcase */
import { coreService } from 'network-utils';
import { LearningPathNodeType } from './learningPathInterfaces';

const CONTENT_TYPE_TO_NODE_TYPE: Record<coreService.LearningPathContentType, LearningPathNodeType> = {
    [coreService.LearningPathContentType.LESSON]: LearningPathNodeType.LESSON,
    [coreService.LearningPathContentType.COURSE]: LearningPathNodeType.COURSE,
    [coreService.LearningPathContentType.CHALLENGE]: LearningPathNodeType.CHALLENGE,
    [coreService.LearningPathContentType.SYSTEM_ASSESSMENT]: LearningPathNodeType.ASSESSMENT
};

export const contentTypeToNodeType = (contentType: coreService.LearningPathContentType): LearningPathNodeType =>
    CONTENT_TYPE_TO_NODE_TYPE[contentType] ?? LearningPathNodeType.MIXED;

export const convertStatus = (serverStatus: string): 'inProgress' | 'completed' | 'notStarted' => {
    switch (serverStatus) {
        case 'started':
            return 'inProgress';
        case 'completed':
            return 'completed';
        case 'not_started':
            return 'notStarted';
        default:
            return 'notStarted';
    }
};

export const progressOrder = ['inProgress', 'notStarted', 'completed'];

export const convertNumber = (num: number): string => {
    if (num >= 1000) {
        const roundedNumber = Math.floor(num / 100) / 10;
        return `${roundedNumber}K`;
    }
    return num.toString();
};

export const convertTimeFormat = (mins: number): string => {
    const hours = Math.floor(mins / 60);
    const remainingMinutes = mins % 60;
    return `${hours}:${remainingMinutes}`;
};

export const formatFullTime = (mins: number): string => {
    const hours = Math.floor(mins / 60);
    const remainingMinutes = mins % 60;
    return `${hours}h:${remainingMinutes}min`;
};
